import { ErrorPage } from './lib/error-page';

export * from './lib/error-page';
export * from './lib/phone-number';
export default ErrorPage;
